// This file is auto-generated by @hey-api/openapi-ts
/* eslint-disable max-len */

import { createClient, createConfig, type Options } from '@hey-api/client-fetch';

import type { ListUsersApiV1UserUsersGetData, ListUsersApiV1UserUsersGetError, ListUsersApiV1UserUsersGetResponse, CreateUserApiV1UserUsersPostData, CreateUserApiV1UserUsersPostError, CreateUserApiV1UserUsersPostResponse, PrivateRouteApiV1UserPrivateGetError, PrivateRouteApiV1UserPrivateGetResponse, PublicRouteApiV1UserPublicGetError, PublicRouteApiV1UserPublicGetResponse } from './types.gen';

export const client = createClient(createConfig());

/**
 * List Users
 * Get a list of all active users in the system
 */
export const listUsersApiV1UserUsersGet = <ThrowOnError extends boolean = false>(options?: Options<ListUsersApiV1UserUsersGetData, ThrowOnError>) => { return (options?.client ?? client).get<ListUsersApiV1UserUsersGetResponse, ListUsersApiV1UserUsersGetError, ThrowOnError>({
    ...options,
    url: '/api/v1/user/users'
}); };

/**
 * Create User
 * Create a new user in the system
 */
export const createUserApiV1UserUsersPost = <ThrowOnError extends boolean = false>(options: Options<CreateUserApiV1UserUsersPostData, ThrowOnError>) => { return (options?.client ?? client).post<CreateUserApiV1UserUsersPostResponse, CreateUserApiV1UserUsersPostError, ThrowOnError>({
    ...options,
    url: '/api/v1/user/users'
}); };

/**
 * Private Route
 * This is a private route that requires authentication
 */
export const privateRouteApiV1UserPrivateGet = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => { return (options?.client ?? client).get<PrivateRouteApiV1UserPrivateGetResponse, PrivateRouteApiV1UserPrivateGetError, ThrowOnError>({
    ...options,
    url: '/api/v1/user/private'
}); };

/**
 * Public Route
 * This is a public route that doesn't require authentication
 */
export const publicRouteApiV1UserPublicGet = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => { return (options?.client ?? client).get<PublicRouteApiV1UserPublicGetResponse, PublicRouteApiV1UserPublicGetError, ThrowOnError>({
    ...options,
    url: '/api/v1/user/public'
}); };